// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/es7.weak-map.of.js
// module id = 680
// module chunks = 0